export default __webpack_public_path__ + "static/media/facebook.ee1e45c1.png";